import { PostCycleCountsMutation } from "~/gql/mutations/postCycleCounts.generated";
import { UpsertRfidScansMutation } from "~/gql/mutations/upsertRfidScans.generated";
import { GetCycleCountHistoryQuery, GetCycleCountRecordQuery } from "~/gql/queries/getCycleCountHistory.generated";

export const engageEndpoints = {
	GetCycleCountHistory: {
		providesTags: ["CycleCountHistory"] as AddTagTypes,
		transformResponse: (res: GetCycleCountHistoryQuery) => res
	},
	GetCycleCountRecord: {
		providesTags: ["CycleCountHistory"] as AddTagTypes,
		transformResponse: (res: GetCycleCountRecordQuery) => res
	},
	PostCycleCounts: {
		invalidatesTags: ["CycleCountHistory"] as AddTagTypes,
		transformResponse: (res: PostCycleCountsMutation) => res
	},
	// No tag: nothing in WorkSuite reads rfidScans back; the BPF bridge consumes them server-side.
	UpsertRfidScans: {
		transformResponse: (res: UpsertRfidScansMutation) => res
	}
};
